import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class PushSubscriptionHttpService extends BaseHttpService<PushSubscriptionPayload> {
  constructor(protected http: HttpClient) {
    super(http);
  }

  getApiRootPath(): string {
    return 'push-subscriptions';
  }

  getVapidPublicKey(): Observable<{ publicKey: string }> {
    return this.http.get<{ publicKey: string }>(
      `${this.apiUrl}/vapid-public-key`
    );
  }

  subscribe(payload: PushSubscriptionPayload): Observable<{ id?: number }> {
    return this.http.post<{ id?: number }>(this.apiUrl, payload);
  }
}
